import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Direction } from '../types/directions';
import { IFooterLink } from '../types/footerLink';
import { IHeaderMenu } from '../types/headerMenu';
import { ILanguage } from '../types/language';
import { IMobileLink } from '../types/mobileLink';
import { IConsolesMenu } from '../types/consoles';
import { IAppMenuItem } from '../types/appMenu';

@Injectable()
export class CmxLayoutService {
  // Layout behavior
  direction = new BehaviorSubject<Direction>('ltr');
  isMobile = new BehaviorSubject<boolean>(false);
  isMobileMenuOpen = new BehaviorSubject<boolean>(false);
  isCollapsed = new BehaviorSubject<boolean>(false);
  isLegalEntityListOpen = new BehaviorSubject<boolean>(false);
  isMobileEntitySelectorOpen = new BehaviorSubject<boolean>(false);
  isMobileLangSelectorOpen = new BehaviorSubject<boolean>(false);
  isMobileAppSelectorOpen = new BehaviorSubject<boolean>(false);
  isGreen = new BehaviorSubject<boolean>(false);

  // Chatbox
  chatbox = new BehaviorSubject<boolean>(false);
  chatboxLabel = new BehaviorSubject<string>('');
  chatboxClick = new EventEmitter<void>();
  chatbotLabel = new BehaviorSubject<string>('');

  // Feedback
  feedback = new BehaviorSubject<boolean>(false);
  feedbackLabel = new BehaviorSubject<string>('');
  feedbackClick = new EventEmitter<void>();

  // Consoles menu
  consolesMenu = new BehaviorSubject<boolean>(false);
  consolesMenuItems = new BehaviorSubject<IConsolesMenu[]>([]);
  consolesMenuClick = new EventEmitter<number | string>();

  // Languages
  language = new BehaviorSubject<boolean>(true);
  languageLabel = new BehaviorSubject<string>('');
  activeLanguageId = new BehaviorSubject<number>(0);
  languages = new BehaviorSubject<ILanguage[]>([]);
  languageChange = new EventEmitter<number | string>();
  languageMobileLabel = new BehaviorSubject<string>('');

  // Users
  userName = new BehaviorSubject<string>('');
  userInitials = new BehaviorSubject<string>('');
  userEmail = new BehaviorSubject<string>('');
  userCountry = new BehaviorSubject<string>('');

  // Footer
  footerLabel = new BehaviorSubject<string>('');
  footerLabelClick = new EventEmitter<void>();
  footerLinks = new BehaviorSubject<IFooterLink[]>([]);
  footerLinkClick = new EventEmitter<number | string>();

  // Mobile Links
  mobileLinks = new BehaviorSubject<IMobileLink[]>([]);
  mobileLinkClick = new EventEmitter<number | string>();

  // Header Menu
  headerMenuItems = new BehaviorSubject<IHeaderMenu[]>([]);
  headerMenuItemClick = new EventEmitter<number | string>();
  headerRendered = new BehaviorSubject<boolean>(false);

  // Loader
  loader = new BehaviorSubject<number>(100);

  // Development direction controller
  directionSwitcher = new BehaviorSubject<boolean>(false);
  directionSelect = new EventEmitter<Direction>();

  // Cemex Apps Menu
  appMenu = new BehaviorSubject<boolean>(false);
  appMenuLabel = new BehaviorSubject<string>('');
  appMenuItems = new BehaviorSubject<IAppMenuItem[]>([]);
  appMenuClick = new EventEmitter<number | string>();

  // Sidebar and Navheader new version
  version = new BehaviorSubject<number>(3);
  needHelpLabel = new BehaviorSubject<string>('');
  ServiceCenterApp = new BehaviorSubject<string>('');
  feedBackTitle = new BehaviorSubject<string>('');
  contactLabel = new BehaviorSubject<string>('');
  developerCenterLabel = new BehaviorSubject<string>('');
  settingsLabel = new BehaviorSubject<string>('');
  supportContact = new BehaviorSubject<IHeaderMenu>({ label: '', id: 0 });
  menuButtonLabel = new BehaviorSubject<string>('');
  disabledProfile = new BehaviorSubject<boolean>(false);
  variantHeader = new BehaviorSubject<string>('positive');
  brandLogo = new BehaviorSubject<string>('cemex_logo');
  sideBarMenuRendered = new BehaviorSubject<boolean>(false);

  // Entity Selector modal
  modalLabelApply = new BehaviorSubject<string>('');
  modalLabelCancel = new BehaviorSubject<string>('');
  modalLabelChoose = new BehaviorSubject<string>('');
  modalLabelEmptyHeader = new BehaviorSubject<string>('');
  modalLabelEmptyMessage = new BehaviorSubject<string>('');
  modalLabelFilter = new BehaviorSubject<string>('');
  modalTitle = new BehaviorSubject<string>('');

  constructor() {}
}
